import React, {
  Fragment, useState, useEffect,
  useRef, memo,
} from 'react';
import cn from 'classnames';
import _ from 'lodash';
import styles from './orders.module.scss';
import { LABEL } from '../../veriables';
import { getObjectValue } from '@utility/utills';
import OrderItemDetail from '@components/OrderItemDetail';

const handleScroll = (isKiosk) => {
  const headers = [...document.querySelectorAll('[data-header]')];
  const sections = [...document.querySelectorAll('[data-section]')];
  const handleObserver = (entries, observe) => {
    const mulitpleIntersectionIds = [];
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        mulitpleIntersectionIds.push({
          id: entry.target.id,
          intersectionRatio: entry.intersectionRatio,
          name: entry.target.dataset.name,
          top: entry.boundingClientRect.top
        });
      }
    });
    const target = mulitpleIntersectionIds.find((e) => { return isKiosk ? (e.top <= 600) : (e.top <= 250); });
    if (target?.id && headers && headers.length > 0) {
      headers.forEach((header) => {
        const Header = header;
        if (header.id === target.id) {
          window.sessionStorage.setItem('screenId', Number(header.id));
          Header.classList = isKiosk ? `w-100 col-12 col-lg-12 row align-items-center justify-content-center px-0 ${styles.selectedMenu} od-container-card-border border-color-primary` : 'card w-100 col-12 text-center px-0 mb-2 background-secondary od-container-card-background od-text-primary text-primary';
          Header.scrollIntoView();
        } else {
          Header.classList = isKiosk ? 'w-100 col-12 col-lg-12 row align-items-center justify-content-center px-0 opacity-50 od-text-secondary text-secondary' : 'card w-100 col-12 text-center px-0 mb-2 od-text-secondary text-secondary';
        }
      });
    }
    sections.forEach((section) => {
      observe.unobserve(section);
    });
  };
  const options = {
    // root: document.querySelector('#menus'),
    rootMargin: '0px',
    threshold: 0,
  };
  const observer = new IntersectionObserver(handleObserver, options);
  sections.forEach((section) => {
    observer.observe(section);
  });
};

const SubMenuItemList = ({
  data,
  backgroundChange,
  handleInfo,
  handleAddToCart,
  showPrice,
  btnColor,
  // cartItemsInfo,
  getCartInfoForLinkedItems,
  getItemQuantity,
  selectedMenuItem,
  handleItemSelection,
  groupedItems,
  isKiosk
}) => {
  const imageRef = useRef(null);
  const [isIntersecting, setIsIntersecting] = useState(false);
  const handleObserver = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setIsIntersecting(entry.isIntersecting);
      }
    });
  };

  const options = {
    // root: document.querySelector('#menus'),
    rootMargin: '0px 0px 500px 0px',
    threshold: [0.25, 0.75]
  };
  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, options);
    if (imageRef?.current) {
      observer.observe(imageRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  const getBadgeName = (menuItem) => {
  if (menuItem.outOfStock) {
    return LABEL().OUT_OF_STOCK;
  }

  const badgeNameMap = {
    1: LABEL().VIEW_ONLY,
    2: LABEL().NEW_ITEM,
    3: LABEL().LIMITED_TIME,
    4: LABEL().FEATURED,
    5: LABEL().SPECIAL,
    6: LABEL().COMING_SOON,
    7: LABEL().LIMITED_QUANTITY,
    8: LABEL().ADDITIONAL_TIME,
    9: LABEL().TIME_RESTRICTED,
  };

  return badgeNameMap[menuItem.badge] || '';
};

  const getBadgeStyle = (menuItem) => {
    if (menuItem.outOfStock) {
      return 'od-badge-nostock';
    }

    const badgeStyleMap = {
      1: 'od-badge-view',
      2: 'od-badge-new',
      3: 'od-badge-limited',
      4: 'od-badge-featured',
      5: 'od-badge-special',
      6: 'od-badge-comingsoon',
      7: 'od-badge-limitedquantity',
      8: 'od-badge-additionaltime',
    };

    return badgeStyleMap[menuItem.badge] || '';
  };

  return (data?.menuItem) ? (
    <div
      ref={imageRef}
      className={cn('col-6 m-0 p-2', styles.menuList)}
    >
      {isIntersecting && (
        <div
          key={data.menuItemId}
          style={{ backgroundColor: backgroundChange(data?.menuItem?.buttonColor) }}
          className={cn('row mx-0 position-relative od-container-card-border btn-ripple', ((data?.menuItem?.buttonColor) || btnColor) ? '' : 'od-container-card-background', 'card h-100 p-0')}
        >
          <div
            className="col-12 flex-wrap d-flex align-items-stretch position-relative px-0"
            role="presentation"
            onClick={() => handleItemSelection(data)}
          >
            {data.menuItem.outOfStock || data.menuItem.badge !== 0 ? (
              <span style={{ top: 0 }} className={cn(selectedMenuItem && Object.is(selectedMenuItem.menuItemId, data.menuItemId) ? styles.removeOutStockHidden : styles.removeOutStock, 'position-absolute fs-14', getBadgeStyle(data.menuItem), (data.price > 0 || (data.menuItem.calories !== null && data.menuItem.calories > 0) || data.menuItem.maximum !== 1) ? styles.badgeWithCalOrPrice : '', data.menuItem.description && (data.menuItem.tags && data.menuItem.tags.length > 0) ? styles.badgeBottomWhenDesciption : '', data.menuItem.tags && data.menuItem.tags.length > 0 ? styles.badgeWithTag : styles.badgeWithoutTag)}>{getBadgeName(data.menuItem)}</span>
            ) : ''}
            {(groupedItems[data.menuItemId] || (getObjectValue(() => data.menuItem.linkType === 1 && getCartInfoForLinkedItems(data.menuItem.links) > 0), false)) && (
              <div className={cn('od-cart-button', selectedMenuItem && Object.is(selectedMenuItem.menuItemId, data.menuItemId) ? styles.orderedQuantityHidden : styles.orderedQuantity)}>
                <svg x="0px" y="0px" viewBox="0 0 465.6183 504">
                  <g>
                    <polygon points="323.9163,503.5753 465.6183,491.1067 419.6804,17.3544 362.2526,128.1079" />
                    <polygon points="347.269,115.8043 407.3161,0 361.8919,0 58.1612,0 15.4776,112.3106" />
                    <polygon points="342.513,134.7204 41.9951,131.5569 0,491.468 304.8084,504" />
                  </g>
                </svg>
                {getObjectValue(() => data.menuItem.linkType === 1, 0) ? getCartInfoForLinkedItems(data.menuItem.links) : getItemQuantity(groupedItems[data.menuItemId])}
              </div>
            )}
            <div
              className={cn(styles.itemImg, 'col-12 p-0 m-0')}
            >
              <img src={isKiosk ? data.menuItem.largeImageUrl : data.menuItem.smallImageUrl} alt="" className="img-fluid mx-auto d-block" />
            </div>
            <div className="col-12 p-2">
              <div className={cn('d-flex col-12 h-100 px-0 mx-0 d-flex align-items-center text-primary od-text-primary', styles.alignItemBaseline)}>
                <div className="fw-700 d-flex align-items-start text-left p-0 od-header-font-family">
                  <span className={cn(isKiosk && 'fs-20', styles.lineHeight)}>
                    {data?.menuItem?.name}
                  </span>
                </div>
              </div>
            </div>
            <div className={cn('col-12 text-right p-2', styles.tagContainer)}>
              {data.menuItem.tags.map((tag) => {
                return (
                  <small className={cn('badge fs-14', styles.tagName)}>
                    {tag.display && (
                    <>
                      {tag.imageUrl ? (
                        <div>
                          <img src={tag.imageUrl} alt={tag.shortName} width="25" height="20" className={cn(styles.tagImg)} />
                        </div>
                      ) : (
                        tag.shortName && (
                        <div className={cn(styles.tagTextBox)} style={{ color: tag.color }}>
                          {tag.shortName}
                        </div>
                        )
                      )}
                    </>
                    )}
                  </small>
                );
              })}
            </div>
            <div
              className={cn('col-12 p-2 px-0 row mx-0 w-100 align-items-end text-primary od-text-primary', isKiosk ? 'fs-20' : 'fs-14')}
            >
              <div className="col-6 text-left px-0">
                {![null].includes(data.menuItem.calories) ? `${data.menuItem.calories} cals` : ''}
              </div>
              <div className={cn('col-6 text-right px-0')}>
                {showPrice(data)}
              </div>
            </div>
          </div>
          {selectedMenuItem && Object.is(selectedMenuItem.menuItemId, data.menuItemId) && (
            <div
              role="presentation"
              onClick={() => handleItemSelection(data)}
              className={cn('position-absolute w-100 h-100', styles.greyTransparent)}
            >
              <div className="h-100 w-100 position-relative">
                <div className={cn('p-2 w-100 h-100 d-flex flex-column justify-content-center m-0')}>
                  <div className={cn('p-2 w-100')}>
                    <button
                      type="button"
                      className="w-100 btn35 btn-secondary od-btn-secondary"
                      onClick={(e) => { e.stopPropagation(); handleInfo(data); }}
                    >
                      <div className="fs-24">{LABEL().MORE_INFO}</div>
                    </button>
                  </div>
                  {groupedItems[data.menuItemId] ? (
                    <>
                      {isKiosk && (
                        <div className={cn('p-2 w-100')}>
                          <button
                            type="button"
                            className="w-100 btn35 btn-secondary od-btn-secondary"
                            onClick={() => { if (!data?.menuItem?.pack && data?.menuItem?.cardType !== 1) handleAddToCart(data, 'modify'); }}
                            disabled={data?.menuItem?.pack || data?.menuItem?.cardType === 1}
                            style={(data?.menuItem?.pack || data?.menuItem?.cardType === 1) ? { cursor: 'not-allowed', opacity: 0.6 } : {}}
                          >
                            <div className="fs-24">{LABEL().MODIFY_ITEM}</div>
                          </button>
                        </div>
                      )}
                      {!(data.menuItem.outOfStock || data.menuItem.badge === 1 || data.menuItem.badge === 6) && (
                        <div className={cn('p-2 w-100')}>
                          <button
                            type="button"
                            className="w-100 btn35 btn-primary btn-ripple od-btn-primary"
                            onClick={() => handleAddToCart(data, 'orderAnother')}
                          >
                            <div className="fs-24">{LABEL().ORDER_ANOTHER}</div>
                          </button>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {!(data.menuItem.outOfStock || data.menuItem.badge === 1 || data.menuItem.badge === 6) && (

                      <div className={cn('p-2 w-100')}>
                        <button
                          type="button"
                          className="w-100 btn35 btn-primary btn-ripple od-btn-primary"
                          onClick={() => handleAddToCart(data, 'order')}
                        >
                          <div className="fs-24">{LABEL().ADD_TO_ORDER}</div>
                        </button>
                      </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  ) : <div />;
};

const WrapperComponent = memo(({
  menus, isKiosk,
  ...props
}) => {
  const wrapperRef = useRef(null);
  useEffect(() => {
    const screenId = window.sessionStorage.getItem('screenId');
    if (wrapperRef?.current && (wrapperRef.current.id === screenId)) {
      wrapperRef.current.scrollIntoView();
    }
  }, []);
  return (
    <div className="col-12 px-1 py-1">
      <div data-section={menus.id} data-name={menus.name} ref={wrapperRef} id={menus.id} className="text-center fs-26 w-100">
        <div
          className="position-relative mb-2"
        >
          <img
            src={menus.imageUrl}
            alt=""
            style={{
              width: '100%',
              height: isKiosk ? '200px' : '70px',
              objectFit: 'cover'
            }}
            className="img-fluid m-auto d-block"
          />
          <div
            className="position-absolute text-white fw-600 col-12"
            style={{
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)'
            }}
          >
            {menus.name}
          </div>
        </div>
      </div>
      {menus.menuItems.map((menu) => {
        return (
          <div className={cn('row mx-0 p-0')} key={menu.id}>
            {menu.groupName && (
              <div className={cn(styles.menuHeader, 'fw-700 fs-20 my-2 ml-2 od-header-font-family')}>
                {menu.groupName}
              </div>
            )}
            {menu.items.map((data) => {
              if (data?.linkedItem) { return null; }
              return (
                <SubMenuItemList
                  data={data}
                  isKiosk={isKiosk}
                  {...props}
                />
              );
            })}
          </div>
        );
      })}
    </div>
  );
}, (prevProps, nextProps) => {
  return _.isEqual(prevProps, nextProps);
});

const KioskMenuItems = (props) => {
  const isKiosk = props.isKiosk;
  const {
    seat,
    menuItem,
    addToCart,
    // cartItemsInfo,
    menuIndex,
    searchString,
    isContinuousScroll
    // cart,
  } = props;

  const [btnColor, setBtnColor] = useState();
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const [info, setInfo] = useState(false);
  useEffect(() => {
    setSelectedMenuItem(null);
  }, [window.sessionStorage.getItem('screenId')]);
  let pendingItems = [];
  if (getObjectValue(() => seat.orders[0].items.length > 0, false)) {
    pendingItems = seat.orders[0].items.filter((e) => e.pending).reduce((a, v) => {
      const orderJson = JSON.parse(v.orderJson);
      const modifierJson = JSON.parse(orderJson.modifierJson);
      if (v.hasLinkedMenuItem) {
        a.push({
          ...v,
          ...modifierJson
        });
      } else if (!v.isLinked && !v.uniqueIdForLinkedItem) {
        a.push({
          ...v,
          ...modifierJson
        });
      }
      return a;
    }, []);
  }
  const groupedItems = _.groupBy(pendingItems || [], (d) => d.menuItemId) || {};
  const getItemQuantity = (cartItem) => {
    let count = 0;
    cartItem.forEach((item) => {
      count += item.quantity;
    });
    return count;
  };

  const getCartInfoForLinkedItems = (itemsList) => {
    let count = 0;
    (itemsList || []).forEach((linkedMenuItem) => {
      if (groupedItems[linkedMenuItem.linkedMenuItemId]) {
        count += getItemQuantity(groupedItems[linkedMenuItem.linkedMenuItemId]);
      }
    });
    return count;
  };

  const handleAddToCart = (data, orderType) => {
    const items = groupedItems[data.menuItemId] || (getObjectValue(() => data.menuItem.linkType === 1 && getCartInfoForLinkedItems(data.menuItem.links) > 0, []));
    if (data.menuItem && !data.menuItem.outOfStock) {
      addToCart(data.menuItemId, data.menuTypeId, items, orderType);
    }
  };

  let nonContinuousSubMenuItemList = [];
  if (searchString === '') {
    nonContinuousSubMenuItemList = _.sortBy(_.chain(menuItem).groupBy('groupName').map((value, key) => ({ groupName: key, items: value, index: _.minBy(value, (o) => o.index).index })).value(), (d) => d.index);
  } else {
    const subMenuList = _.orderBy(menuItem, [(menu) => menu?.menuItem?.name?.toLowerCase()], ['asc']);
    nonContinuousSubMenuItemList.push({ items: subMenuList });
  }

  let subMenuItemList = [];
  if (searchString === '') {
    subMenuItemList = props.allMenusHashTable;
  } else {
    subMenuItemList = props.filteredItemsList || [];
  }
  useEffect(() => {
    if (props.menusList[menuIndex]) {
      if (window.sessionStorage.getItem('menuTypeId') && _.find(props.menusList[menuIndex].screens, { id: Number(window.sessionStorage.getItem('menuTypeId')) })) {
        const arrayIndex = _.findIndex(props.menusList[menuIndex].screens, ['id', Number(window.sessionStorage.getItem('menuTypeId'))]);
        if (arrayIndex >= 0) {
          setBtnColor(props.menusList[menuIndex].screens[arrayIndex].buttonColor);
        }
      } else {
        const arrayIndex = _.findIndex(props.menusList[menuIndex].screens, ['id', ((props?.menusList?.[menuIndex]?.screens?.[0]?.id) || [])]);
        if (arrayIndex >= 0) {
          setBtnColor(props.menusList[menuIndex].screens[arrayIndex].buttonColor);
        }
      }
    }
  }, [props.menusList, menuIndex]);

  const backgroundChange = (screen) => {
    let buttonColor = '';
    if (screen) {
      buttonColor = screen;
    } else if (btnColor) {
      buttonColor = btnColor;
    }
    return buttonColor;
  };

  const showPrice = (data) => {
    const minPrice = data.menuItem.minPrice;
    const maxPrice = data.menuItem.maxPrice;
    let price = '';
    if ((minPrice > 0) && (maxPrice > 0)) {
      price = `${LABEL().CURRENCY_SYMBOL}${(minPrice).toFixed(2)} - ${LABEL().CURRENCY_SYMBOL}${(maxPrice).toFixed(2)}`;
    } else if ((minPrice > 0) && (maxPrice === 0 || maxPrice === null)) {
      price = `From ${LABEL().CURRENCY_SYMBOL}${(minPrice).toFixed(2)}`;
    } else if (price != 0) {
      price = `${LABEL().CURRENCY_SYMBOL}${(data.price).toFixed(2)}`;
    }
    return price;
  };

  const handleInfo = (item) => {
    setInfo(true);
    setSelectedMenuItem(item);
  };

  const handleItemSelection = (item) => {
    if (selectedMenuItem && Object.is(selectedMenuItem.menuItemId, item.menuItemId)) {
      setSelectedMenuItem(null);
    } else {
      setSelectedMenuItem(item);
    }
  };

  return (
    <Fragment>
      {isContinuousScroll ? (
        <div
          onScroll={() => handleScroll(isKiosk)}
          id="menus"
          className={cn('col-12 px-0 h-100 overflowY', styles.menuItems, 'w-100')}
        >
          {subMenuItemList && subMenuItemList.length > 0 ? (
            subMenuItemList.map((d) => {
              return (
                <WrapperComponent
                  menus={d}
                  handleAddToCart={handleAddToCart}
                  showPrice={showPrice}
                  handleInfo={handleInfo}
                  backgroundChange={backgroundChange}
                  btnColor={btnColor}
                  isKiosk={isKiosk}
                  handleItemSelection={handleItemSelection}
                  getCartInfoForLinkedItems={getCartInfoForLinkedItems}
                  getItemQuantity={getItemQuantity}
                  selectedMenuItem={selectedMenuItem}
                  groupedItems={groupedItems}
                />
              );
            })) : (
              <div className="h-100 d-flex justify-content-center align-items-center p-10 text-center fs-26">
                {searchString !== '' ? (
                  <div>
                    {LABEL().ITEM_NOT_FOUND}
                  </div>
                ) : (
                  <div>
                    {LABEL().MENU_ITEM_NOT_ITEM}
                  </div>
                )}
              </div>
          )}
          <div
            id="sticky"
            className="position-sticky text-right px-1 d-none"
            style={{
              bottom: '5px',
              zIndex: 99
            }}
          >
            <i
              role="presentation"
              // onClick={() => menus.scrollTo(0, 0)}
              className="rounded fa fa-arrow-circle-up fs-22 p-1 od-app-background-color background-primary od-text-secondary text-secondary"
              aria-hidden="true"
            />
          </div>
        </div>
      ) : (
        <div id="nonContinousScroll" className={cn('col-12 px-0 h-100 overflowY', styles.menuItems, 'w-100')}>
          {(nonContinuousSubMenuItemList?.[0]?.items?.length > 0) ? (
            nonContinuousSubMenuItemList.map((menu) => (
              <div className={cn('row mx-0 p-0')} key={menu.id}>
                {menu.groupName && (
                  <div className={cn(styles.menuHeader, 'fw-700 fs-20 my-2 ml-2 od-header-font-family text-primary od-text-primary')}>
                    {menu.groupName}
                  </div>
                )}
                {menu.items.map((data) => {
                  if (data?.linkedItem) { return null; }
                  return (
                    <SubMenuItemList
                      data={data}
                      handleAddToCart={handleAddToCart}
                      showPrice={showPrice}
                      handleInfo={handleInfo}
                      backgroundChange={backgroundChange}
                      btnColor={btnColor}
                      isKiosk={isKiosk}
                      handleItemSelection={handleItemSelection}
                      getCartInfoForLinkedItems={getCartInfoForLinkedItems}
                      getItemQuantity={getItemQuantity}
                      selectedMenuItem={selectedMenuItem}
                      groupedItems={groupedItems}
                    />
                  );
                })}
              </div>
            ))) : (
              <div className="h-100 d-flex justify-content-center align-items-center p-10 text-center fs-26">
                {searchString !== '' ? (
                  <div>
                    {LABEL().ITEM_NOT_FOUND}
                  </div>
                ) : (
                  <div>
                    {LABEL().MENU_ITEM_NOT_ITEM}
                  </div>
                )}
              </div>
          )}
        </div>
      )}
      {info && (
        <OrderItemDetail
          info={info}
          setInfo={setInfo}
          itemInfo={selectedMenuItem}
          addToCart={props.addToCart}
        />
      )}
    </Fragment>
  );
};

export default KioskMenuItems;
